import { OrganizationSwitcher } from '@/components/ui/organization-switcher';

/** Slim account switcher row for gate pages (activate-account, setup-payment). */
export function BlockingPageAccountBar() {
  return (
    <div className="flex shrink-0 items-center justify-end px-4 py-3 sm:px-6">
      <OrganizationSwitcher compact prominent align="end" />
    </div>
  );
}
